import { z } from "zod";

const UserInfo = z.object({
  _id: z.string(),
  name: z.string().nullish(),
  email: z.string().nullish(),
});

export type UserInfo = z.infer<typeof UserInfo>;

export const getAdvancedFlows = {
  input: z.object({ getUsers: z.boolean() }), // TODO @mlewis850 fill this out with actual types
  output: z.object({
    advancedFlows: z.any(),
    users: z.map(z.string(), UserInfo).nullish(),
  }),
};
